<div class="action-header">
    <div class="d-flex align-item-center justify-between p-t-9 p-b-9">
        @if(context === actionContextEnum.PROFILE) {
        <p class="action-header-title m-b-0">
            {{ "configuration-page.action-dialog.my-profile" | translate | capitalize }}
        </p>
        } @else {
        <p class="action-header-title m-b-0">
            @if(user) {
            {{ "configuration-page.action-dialog.edit-user" | translate | capitalize }}
            } @else {
            {{ "configuration-page.action-dialog.new-user" | translate | capitalize }}
            }
        </p>
        <div class="d-flex align-item-center g-20">
            <div>
                <app-custom-switch [checked]="isActive" [disabled]="false" [text]="switchText"
                    (currentStateEmitter)="emitCheckState($event)"></app-custom-switch>
            </div>
            <div (click)="close()" hideLTLarge>
                <fa-icon class="font-16 icon" [icon]="['fal', 'xmark']"></fa-icon>
            </div>

        </div>
        }

    </div>
    <div class="action-header-submenus border-separator">
        <div class="action-header-submenus-wrapper d-flex g-30 p-t-15 p-b-15">
            @for (subMenu of subMenus; track subMenu) {
            @if(context === actionContextEnum.PROFILE) {
            <div class="cursor-pointer" [ngClass]="{
                        'text-underline' : subMenu.isSelected, 
                    'd-none': subMenu.id === subMenusEnum.ROLES_AND_PERMISSIONS}" (click)="toggleSubMenu(subMenu.id)">
                {{ subMenu.value }}
            </div>
            } @else {
            <div class="cursor-pointer" [ngClass]="{
                    'text-underline' : subMenu.isSelected, 
                    'disabled': (!user && (subMenu.id !== subMenusEnum.PROFILE_DATA)) || 
                    (subMenu.id === subMenusEnum.ROLES_AND_PERMISSIONS && isAdmin)}"
                (click)="toggleSubMenu(subMenu.id)">
                {{ subMenu.value }}
            </div>
            }
            }

        </div>

    </div>
</div>